// import { canUseDOM } from 'exenv';

export function authorAllFeedLoading(resp = {}, store = {}) {
  return {
    type: 'AUTHOR_ALL_FEED_LOADING',
    authorAllFeed: resp,
    store
  };
}

export function authorAllFeedLoaded(resp = {}, store = {}) {
  return {
    type: 'AUTHOR_ALL_FEED_LOADED',
    authorAllFeed: resp,
    store
  };
}

export function authorAllFeedLoadError(error, store = {}) {
  return {
    type: 'AUTHOR_ALL_FEED_ERROR',
    authorAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}

export function authorAllFeedAllStoriesRendered() {
  return {
    type: 'AUTHOR_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

export function authorAllFeedISLoading(resp = {}, config) {
  return {
    type: 'AUTHOR_ALL_FEED_IS_LOADING',
    authorAllFeed: resp,
    config
  };
}

export function authorAllFeedISLoaded(resp = {}, config) {
  return {
    type: 'AUTHOR_ALL_FEED_IS_LOADED',
    authorAllFeed: resp,
    config
  };
}

export function authorAllFeedISError(resp = {}, config) {
  return {
    type: 'AUTHOR_ALL_FEED_IS_ERROR',
    authorAllFeed: resp,
    config
  };
}
